module.exports = __webpack_public_path__ + "static/exterior-1-41701ca2093e8c95cbd149d45b3c8f59.jpg";